
import { config, apiPath } from "@backstagex/core/src/config";

const fields = [
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '分類標題',
    model: 'title',
    placeholder: '標題',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: 'icon',
    model: 'icon',
    placeholder: 'icon',
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'number',
    label: '權重',
    model: 'sort',
    required: true,
    validator: function () {
      this.validation();
    },
  }
];

export default fields;
